<template>
    <v-dialog @keydown.left="goLeft"  @keydown.right="goRight" @keydown.esc="hide" v-model="show" loading fullscreen hide-overlay transition="dialog-bottom-transition" style="overflow-x:hidden !important;">
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="opacity:0.1 !important;">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>
        <v-card v-if="show" dark style="background:rgba(0,0,0,0.9)" >
            <v-toolbar   style="cursor:pointer;z-index: 1;position:relative;background: transparent;" dark >
                <v-btn icon dark @click="hide">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="this.$vuetify.breakpoint.mdAndUp">Action</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="this.$vuetify.breakpoint.mdAndUp" style="margin-left: -150px;" icon dark @click="goLeft">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-items style="width: 400px;">
                    <v-list-item>
                        <v-list-item-avatar >
                            <v-img
                                    :src="'/api/images/cards/streamer_images/'+card_data.STID+'/avatar.png'"
                            ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">{{card_data.NAME}}</v-list-item-title>
                            <v-list-item-subtitle>med {{card_data.USER_NAME}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>

                        <v-btn style=""  small class="mx-auto" :class="rank_color">
                            {{rank_text}}
                        </v-btn>
                    </v-list-item>

                </v-toolbar-items>
                <v-btn v-if="this.$vuetify.breakpoint.mdAndUp" icon dark @click="goRight">
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>

                <v-spacer></v-spacer>


                <v-progress-linear
                        v-if="loading"
                        style="position:absolute;bottom:0;left:0;"
                        color="teal"
                        height="10"
                        value="100"
                        striped
                        indeterminate
                ></v-progress-linear>

            </v-toolbar>









            <v-card-text>

            </v-card-text>
        </v-card>

        <div   id="renderContainerAction" :style="{'height':$vuetify.breakpoint.mdAndUp? '100%':'80%'}"  style="z-index:0;top:0;position:absolute;width:100%;">
            <canvas :class="faded" id="renderCanvasAction"></canvas>
        </div>
        <canvas style="display:none;visibility:hidden;" id="normalMapper" height="890" width="640"></canvas>

        <v-navigation-drawer
                absolute
                permanent
                class="transparent"
                right
                dark
                clipped
                floating
                width="400"
                v-if="$vuetify.breakpoint.mdAndUp && show && (isMine || showoff)"
        >
            <v-container fill-height fluid>
                <v-row align="center"
                       justify="center">
                    <v-col>
                        <v-card
                                max-width="400"

                        >
                            <v-card-text>
                                <div class="overline mb-4 text-center">Action-kort</div>
                                <div class="text--primary text-center" v-if="showoff">
                                    När ett Action-kort används visas det i vanliga fall upp i streamen kortet tillhör<span v-if="card_data.VIDEO.video_id"> och klippet nedan spelas upp,</span> men nu syns det bara här!
                                </div>

                                <div class="text--primary text-center" v-else>
                                    När detta kort används visas det upp i <span v-if="card_data.USER_NAME[card_data.USER_NAME.length-1]!=='s' && card_data.USER_NAME[card_data.USER_NAME.length-1]!=='x'">{{card_data.USER_NAME}}s</span><span v-else>{{card_data.USER_NAME}}</span> stream <span v-if="card_data.VIDEO.video_id"> och klippet nedan spelas upp</span>. Ett använt action-kort försvinner.
                                </div>
                                <v-row
                                        v-if="card_data.VIDEO.video_id==='FFA'"
                                >
                                    <v-col>
                                        <v-text-field
                                                dense
                                                outlined
                                                label="Youtube-länk"
                                                placeholder="https://youtube...."
                                                v-model="video_url"

                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row v-if="card_data.VIDEO.video_id==='FFA'" style="margin-top:-20px;" justify="center">
                                    <v-col>
                                        <v-text-field
                                                dense
                                                outlined
                                                label="Start-tid"
                                                suffix="sekunder"
                                                placeholder="0"
                                                type="number"
                                                v-model="video_start"

                                        ></v-text-field>
                                    </v-col>
                                    <v-col style="margin-top:8px;">
                                        <span >Spelas i <b>{{card_data.VIDEO.start}}</b> sekunder</span>
                                    </v-col>

                                </v-row>

                            </v-card-text>



                            <v-img @click="yt_clicked" style="cursor:pointer;" v-if="card_data.VIDEO.video_id && card_data.VIDEO.video_id!=='FFA'" :src="yt_image">

                            </v-img>









                        </v-card>
                        <v-row v-if="showoff">
                            <v-col></v-col>
                            <v-col v-if="card_data.VIDEO.video_id!=='FFA'">
                                <v-btn v-if="!isUsing" @click="useTestCard" text><v-icon>send</v-icon> Test-Använd</v-btn>
                                <v-btn loading v-else><v-icon>send</v-icon> Använder</v-btn>
                            </v-col>
                            <v-col v-if="card_data.VIDEO.video_id==='FFA'">
                                <v-btn v-if="!isUsing" @click="useTestCardVideo" text><v-icon>send</v-icon> Test-Använd</v-btn>
                                <v-btn loading v-else><v-icon>send</v-icon> Använder</v-btn>
                            </v-col>
                            <v-col>

                            </v-col>

                        </v-row>
                        <v-row v-else>
                            <v-col></v-col>
                            <v-col v-if="card_data.VIDEO.video_id!=='FFA'">
                                <v-btn v-if="!isUsing" @click="useCard" text><v-icon>send</v-icon> Använd</v-btn>
                                <v-btn loading v-else><v-icon>send</v-icon> Använder</v-btn>
                            </v-col>
                            <v-col v-if="card_data.VIDEO.video_id==='FFA'">
                                <v-btn v-if="!isUsing" @click="useCardVideo" text><v-icon>send</v-icon> Använd</v-btn>
                                <v-btn loading v-else><v-icon>send</v-icon> Använder</v-btn>
                            </v-col>
                            <v-col>

                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>
            </v-container>





        </v-navigation-drawer>

        <v-row style="position:absolute;bottom:0;" align="center" justify="center" v-if="this.$vuetify.breakpoint.smAndDown && (isMine || showoff)">
            <v-col cols="12" align="center">
                <v-card
                        dark
                        max-width="400"
                >
                    <v-card-text>
                        <div class="overline mb-4 text-center">Action-kort</div>
                        <div class="text--primary text-center" v-if="showoff">
                            När ett Action-kort används visas det i vanliga fall upp i streamen kortet tillhör<span v-if="card_data.VIDEO.video_id"> och klippet nedan spelas upp,</span> men nu syns det bara här!
                        </div>
                        <div v-else class="text--primary text-center">
                            När detta kort används visas det upp i <span v-if="card_data.USER_NAME[card_data.USER_NAME.length-1]!=='s' && card_data.USER_NAME[card_data.USER_NAME.length-1]!=='x'">{{card_data.USER_NAME}}s</span><span v-else>{{card_data.USER_NAME}}</span> stream. Ett använt action-kort försvinner.
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <div v-if="showoff">
                 <v-col align="center" v-if="card_data.VIDEO.video_id!=='FFA'">
                     <v-btn dark v-if="!isUsing" @click="useTestCard" text><v-icon>send</v-icon> Test-Använd</v-btn>
                     <v-btn dark loading v-else><v-icon>send</v-icon> Använder</v-btn>
                 </v-col>
                 <v-col align="center" v-if="card_data.VIDEO.video_id==='FFA'">
                     <v-btn dark v-if="!isUsing" @click="useTestCardVideo" text><v-icon>send</v-icon> Test-Använd</v-btn>
                     <v-btn dark  loading v-else><v-icon>send</v-icon> Använder</v-btn>
                 </v-col>
            </div>
            <div v-else>
                <v-col align="center" v-if="card_data.VIDEO.video_id!=='FFA'">
                    <v-btn dark v-if="!isUsing" @click="useCard" text><v-icon>send</v-icon> Använd</v-btn>
                    <v-btn dark loading v-else><v-icon>send</v-icon> Använder</v-btn>
                </v-col>
                <v-col align="center" v-if="card_data.VIDEO.video_id==='FFA'">
                    <v-btn dark v-if="!isUsing" @click="useCardVideo" text><v-icon>send</v-icon> Använd</v-btn>
                    <v-btndark  loading v-else><v-icon>send</v-icon> Använder</v-btndark>
                </v-col>
            </div>

        </v-row>







    </v-dialog>
</template>

<script>
    import * as Three from 'three'
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
    import {ActionCard3D} from "../helpers/ActionCard3D"






    export default {
        name: "ActioncardHolder",
        components: {},
        props:{
            "card_data":Object,
            "show":Boolean,
            "showoff":Boolean
        },
        data(){
            return{
                loading:true,
                camera: null,
                scene: null,
                renderer: null,
                mesh: null,
                controls:null,
                card:null,
                camToSave:{},
                model:1,
                collection:"",
                byRank:-1,
                byModel:-1,
                mobileShow:false,
                renderCanvas:null,
                renderContainer:null,
                actioncard3d:null,
                faded:"",
                isUsing:false,
                video_url:"",
                video_start:0,
                video_id_showoff:""


            }
        },
        methods: {
            yt_clicked:function(){
                let url=this.card_data.VIDEO.url;
                let win = window.open(url, '_blank');
                win.focus();
            },

            hide:function(){
                this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);
                this.$emit("hide")
            },
            goLeft:function(){
                this.$emit("goLeft");
            },
            goRight:function(){
                this.$emit("goRight");
            },

            init: function() {
                this.renderCanvas= document.getElementById('renderCanvasAction');
                this.renderContainer= document.getElementById('renderContainerAction');

                console.log("IN INIT!");
                this.camera = new Three.PerspectiveCamera(75, this.renderContainer.clientWidth/this.renderContainer.clientHeight, 0.1, 1000);
                this.camera.position.z = 10;


                this.scene = new Three.Scene();

                let light1 = new Three.PointLight( "white", 0.75 );
                let light2 = new Three.PointLight( "white", 0.75 );
                let light3 = new Three.AmbientLight( "white", 0.2 );
                light1.position.set( 0, 5, 50 );
                light2.position.set(0, 5, -50 );

                this.scene.add(light1);
                this.scene.add(light2);
                this.scene.add(light3);

                this.renderer = new Three.WebGLRenderer({canvas:this.renderCanvas,antialias:true,alpha:true,preserveDrawingBuffer: true });
                this.renderer.sortObjects = false;

                this.renderer.setSize(this.renderContainer.clientWidth, this.renderContainer.clientHeight);
                this.controls = new OrbitControls(this.camera, this.renderer.domElement);
                this.controls.enableDamping=true;
                this.controls.maxDistance=10;
                this.controls.minDistance=5;
                this.controls.enablePan=false;
                this.controls.autoRotate=true;
                this.controls.dampingFactor=0.05;
                this.controls.autoRotateSpeed=5;

                this.controls.rotateSpeed=1;

                this.camera.position.z=10;

                this.camera.position.z=10;
                this.camToSave.position = this.camera.position.clone();
                this.camToSave.rotation = this.camera.rotation.clone();
                this.camToSave.controlCenter = this.controls.target.clone();
                //container.appendChild(this.renderer.domElement);
                this.updateCard();
                this.loading=false;


            },

            onResize:function(){
                //let container=document.getElementById('container0');
                console.log("RESIZE");
                if(this.show){
                    this.camera.aspect = document.getElementById("renderContainerAction").clientWidth / document.getElementById("renderContainerAction").clientHeight;
                    this.camera.updateProjectionMatrix();

                    document.getElementById("renderCanvasAction").width=document.getElementById("renderContainerAction").clientWidth;
                    document.getElementById("renderCanvasAction").height=document.getElementById("renderContainerAction").clientHeight;


                    this.renderer.setSize( document.getElementById("renderContainerAction").clientWidth , document.getElementById("renderContainerAction").clientHeight );
                }

            },
            animate: function() {
                requestAnimationFrame(this.animate);
                this.controls.update();
                this.renderer.render(this.scene, this.camera);
            },
            updateCard:function(){
                this.faded="";
                this.controls.autoRotateSpeed=5;
                this.isUsing=false;


                let ac_p=new ActionCard3D(this.card_data,this.$store);
                    let ac=ac_p.render();
                    ac_p.updateText(this.card_data.TEXT);

                let removeMe = this.scene.getObjectByName("card");
                    if(removeMe!==null){
                        this.scene.remove(removeMe);
                    }
                    ac.name="card";
                    //this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);
                    this.scene.add(ac);
                    this.actioncard3d=ac_p;


            },
            get_card_uq:function(){
                this.collection="";
                this.byRank=-1;
                this.byModel=-1;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_card_uq?CID='+this.card_data.CID;

                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("err")

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText==="no data"){
                            return {"COLLECTION_NAME":"Okänd","BYMODEL":0,"BYRANK":0}
                        }
                        else{
                            let data = JSON.parse(http.response);
                            self.byModel=data[0].BYMODEL;
                            self.byRank=data[0].BYRANK;
                            self.collection=data[0].COLLECTION_NAME



                        }

                    }


                };
                http.send();
            },
            restoreCamera(position, rotation, controlCenter){
                this.camera.position.set(position.x, position.y, position.z);
                this.camera.rotation.set(rotation.x, rotation.y, rotation.z);
                this.controls.target.set(controlCenter.x, controlCenter.y, controlCenter.z);
                this.controls.update();
            },

            animateUse(){
                this.isUsing=true;
                this.actioncard3d.animateUse();
                let self=this;
                for(let i=0;i<10;i++){
                    setTimeout(function(){
                        self.controls.autoRotateSpeed+=i;

                    },i*200)
                }
                setTimeout(function(){
                    self.faded="fade-out";
                    self.$store.commit("update_snackbar","Kort använt");

                },3000);
                setTimeout(function(){

                    self.$emit("done");
                    self.updateCard();
                    self.$emit("hide");


                },7000);

            },
            useCardVideo(){

                const youtube_regex = /^.*(youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|&vi?=)([^#&?]*).*/
                const parsed = this.video_url.match(youtube_regex);
                let video_id="";
                if (parsed && parsed[2]) {
                    video_id=parsed[2]
                } else {
                    self.$store.commit("update_snackbar","Video-länken verkar felaktig.");
                    self.loading=false;
                    return
                }
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let self=this;
                let url = '/api/use_action_card?id='+this.card_data.ACID+"&vid="+video_id+"&start="+this.video_start;

                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        self.$store.commit("update_snackbar","Streamerns Hicards-widget är offline");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.animateUse();


                    }

                };
                http.send();
            },




            useCard(){


                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let self=this;
                let url = '/api/use_action_card?id='+this.card_data.ACID;

                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        self.$store.commit("update_snackbar","Streamerns Hicards-widget är offline");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.animateUse();


                    }

                };
                http.send();
            },
            useTestCard(){
                this.animateUse();
                let self=this;
                setTimeout(function(){
                    self.isUsing=false;
                },8000)
            },
            useTestCardVideo(){

                const youtube_regex = /^.*(youtu\.be\/|vi?\/|u\/\w\/|embed\/|\?vi?=|&vi?=)([^#&?]*).*/
                const parsed = this.video_url.match(youtube_regex);
                let video_id="";
                if (parsed && parsed[2]) {
                    video_id=parsed[2]
                } else {
                    self.$store.commit("update_snackbar","Video-länken verkar felaktig.");
                    self.loading=false;
                    return
                }
                this.video_id=video_id;
                this.animateUse();
                let self=this;
                setTimeout(function(){
                    self.isUsing=false;
                },8000)
            },




        },
        mounted() {
            if(this.card_data!==null){
                let self=this;

                setTimeout(function(){
                    self.init();
                    self.animate();
                    window.addEventListener('resize', self.onResize)
                },500);
            }
        },
        watch:{
            card_data:function(){

                if(this.card_data!==null && this.show){
                    console.log(this.scene);
                    if(this.scene===null){
                        let self=this;

                        setTimeout(function(){
                            self.init();
                            self.animate();
                            window.addEventListener('resize', self.onResize)
                        },500);


                    }
                    else{
                        let self=this;
                        setTimeout(function(){
                            self.onResize();

                        },500);

                        this.updateCard();

                    }
                }
                else{
                    console.log(this.card_data)
                }
            }
        },
        computed:{
            yt_image:function(){
              return `https://img.youtube.com/vi/${this.card_data.VIDEO.video_id}/0.jpg`
            },
            isMine:function(){
              let id=window.location.pathname.substring(11);

              return id.toString()===this.$store.state.STREAMER.SID.toString();
            },

            rank_color:function(){
                if(this.card_data.RANK===0){
                    return "green"
                }
                else if(this.card_data.RANK===1){
                    return "blue"
                }
                else if(this.card_data.RANK===2){
                    return "purple"
                }
                else if(this.card_data.RANK_===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.card_data.RANK===0){
                    return "Vanlig"
                }
                else if(this.card_data.RANK===1){
                    return "Ovanlig"
                }
                else if(this.card_data.RANK===2){
                    return "Epic"
                }
                else if(this.card_data.RANK===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            },
            float:function(){
                return (Math.sqrt((this.card_data.FLOAT_X*this.card_data.FLOAT_X)+(this.card_data.FLOAT_Y*this.card_data.FLOAT_Y))/Math.sqrt(2));
            }
        }
    }
</script>

<style scoped>
    .fade-out {
        animation: fadeOut ease 5s;
        -webkit-animation: fadeOut ease 5s;
        -moz-animation: fadeOut ease 5s;
        -o-animation: fadeOut ease 5s;
        -ms-animation: fadeOut ease 5s;
    }
    @keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-moz-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-o-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-ms-keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>
